export function ReportExecutiveSummary({ text }) {
  const paragraphs = (text || "").split("\n\n").filter((p) => p.trim().length > 0);
  return (
    <div className="space-y-3 text-[15px] leading-relaxed text-foreground">
      {paragraphs.map((p, i) => (
        <p key={`exec-${i}-${p.slice(0, 24)}`}>{p}</p>
      ))}
    </div>
  );
}
